import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAoo-SYN9cFn7HiPZ0FvonU0G3DJxxbtJI",
  authDomain: "coryg-media.firebaseapp.com",
  databaseURL: "https://coryg-media.firebaseio.com",
  projectId: "coryg-media",
  storageBucket: "coryg-media.appspot.com",
  messagingSenderId: "550523289012",
  appId: "1:550523289012:web:2f8f27fefe16a7a1b1c6e1",
  measurementId: "G-J6WD1ZBR6X"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
export default firebaseApp;
